module.exports = __webpack_public_path__ + "static/media/sf-pro-text-medium.000f45ba.woff";